import React from "react";
import PropTypes from "prop-types";
import {
  AS_IS,
  INCIDENT_RELATED,
  OFFER
} from "MODULES/IncomingQuotes/constants";

const quoteStyle = lineItem => {
  if (lineItem.incident_related || lineItem.quote_type === INCIDENT_RELATED) {
    return { borderLeft: "3px solid #f44336" };
  }

  switch (lineItem.quote_type) {
    case AS_IS:
      return { borderLeft: "3px solid #f44336" };
    case OFFER:
      return { borderLeft: "3px solid #18b5fc" };
    default:
      return {};
  }
};

export default function LineItemStatusCell({ lineItem, children }) {
  return <td style={quoteStyle(lineItem)}>{children}</td>;
}

LineItemStatusCell.propTypes = {
  lineItem: PropTypes.shape({
    cost: PropTypes.string,
    quote_type: PropTypes.string
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/LineItemStatusCell/LineItemStatusCell.jsx